<template>
  <div styleName="silentList" v-if="silentListShow" :style="{width: typeof width === 'string' ? ~width.indexOf('px') ? width : `${width}px` : `${width}px`, height: typeof height === 'string' ? ~height.indexOf('px') ? height : `${height}px` : `${height}px`}">
    <div styleName="title">
      {{ $t('silenceList[0]') }}
    </div>
    <div styleName="lists">
      <div styleName="subtitle">{{ $t('silenceList[1]') }}</div>
      <ul styleName="listWrapper" v-if="silentUserList.length" @click="_cancleSilence">
        <li
          styleName="listItem"
          v-for="user in silentUserList"
          :key="user.userid">
          {{ user.alias }}
          <div styleName="mask" :data-role="user.userid">{{ $t('cancelSilence') }}</div>
        </li>
      </ul>
      <div styleName="emptyList" v-else>{{ $t('shutuplistIsNull') }}</div>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import { signalSdk } from '@/utils/getSDK'

export default {
  name: 'SilentList',
  mixins: [CSSModules(styles)],
  props: {
    width: {
      default: '100%'
    },
    height: {
      default: '100%'
    }
  },
  computed: {
    silentListShow () {
      return this.$store.state.chatBox.showSilentList
    },
    silentUserList () {
      return this.$store.state.chatBox.silentUserList
    }
  },
  methods: {
    _cancleSilence (e) {
      if (e.target.tagName === 'DIV') {
        let studentID = e.target.dataset.role
        if (e.target.dataset.role) {
          signalSdk.disSilenceAStudent(Number(studentID)).then((data) => {
            console.log('解禁言成功！')
            this.$store.dispatch('deleteUserFromSilenceList', studentID)
          }).catch((err) => {
            console.log(`解禁言失败，${err}`)
          })
        }
      }
    }
  }
}
</script>

